import axios from "axios";
import React, { useEffect, useState } from "react";
import "./Weather.css";
import Temperature from "./Temperature";
import CurrentDate from "./CurrentDate";
import DailyForecast from "./DailyForecast";

export default function Weather() {
  const [apiCity, setApiCity] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [cityTemp, setCityTemp] = useState("");
  const [time, setTime] = useState("");
  const [humidity, setHumidity] = useState("");
  const [wind, setWind] = useState("");
  const [weatherDescription, setWeatherDescription] = useState("");
  const [icon, setIcon] = useState("");
  const [coordinates, setCoordinates] = useState({});

  useEffect(function () {
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    function success(pos) {
      axios(
        `https://api.openweathermap.org/data/2.5/weather?lat=${pos.coords.latitude}&lon=${pos.coords.longitude}&appid=5723740d8d0f3d5046687fbab7668982&units=metric`
      ).then(handleWeatherResponse);
    }

    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  }, []);

  function handleWeatherResponse(response) {
    setApiCity(response.data.name);
    setCoordinates(response.data.coord);
    setCityTemp(Math.round(response.data.main.temp));
    setTime(response.data.dt);
    setHumidity(response.data.main.humidity);
    setWind(response.data.wind.speed);
    setWeatherDescription(response.data.weather[0].description);
    setIcon(
      `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
    );
  }

  function handleSubmit(event) {
    event.preventDefault();

    let url = `https://api.openweathermap.org/data/2.5/weather?&q=${searchCity}&appid=5723740d8d0f3d5046687fbab7668982&units=metric`;
    axios(url).then(handleWeatherResponse);
  }

  function handleTextChange(event) {
    setSearchCity(event.target.value);
  }

  return (
    <div className="weather">
      <form onSubmit={handleSubmit} className=" row form-search">
        <div className="col-5 ">
          <input
            type="text"
            value={searchCity}
            placeholder="enter a city..."
            className="form-control"
            onChange={handleTextChange}
          />
        </div>
        <div className="col-2 ">
          <input
            type="submit"
            value="search"
            className="btn btn-primary search-button"
          />
        </div>
      </form>

      <div className="row">
        <div className="col-6">
          <img src={icon} alt="weatherIcon" className="icon-pic" />

          <Temperature celsius={cityTemp} />
          <ul className="weather-components">
            <li>Humidity: {humidity}%</li>
            <li>Wind: {wind}km/h</li>
          </ul>
        </div>
        <div className="col-6">
          <h1 className="city">{apiCity}</h1>
          <ul className="weather-components">
            <CurrentDate dateTime={time} />
            <li>{weatherDescription}</li>
          </ul>
        </div>
        <DailyForecast coordinates={coordinates} />
      </div>
    </div>
  );
}
